module.exports = __webpack_public_path__ + "img/logo.d589ee6c.png";